// ════════════════════════════════════════════════════════════════════════
//  PASO 1 DE RECUPERAR LA CONTRASEÑA — "dime tu correo"
//
//  Esta pantalla es PÚBLICA y cualquiera puede escribir en ella el correo de
//  otra persona. Por eso no confirma nada: tanto si la cuenta existe como si no,
//  enseña exactamente el mismo texto. Si dijera "ese correo no está registrado",
//  se convertiría en un buscador de quién tiene cuenta aquí, que es justo el
//  primer paso de cualquier ataque dirigido.
//
//  El texto lo escribe el servidor (app/routes/auth.py) para que haya UNA sola
//  versión de la frase y no dos que puedan acabar diciendo cosas distintas.
// ════════════════════════════════════════════════════════════════════════
import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import API, { mensajeDeError } from '../api';
import './Login.css';
import { useT } from '../i18n';
import LangToggle from '../components/LangToggle';
import { IS_PHONE } from '../device';
import { useLogo } from '../theme';

export default function ForgotPassword() {
  const logoSrc = useLogo();
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const t = useT();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (enviando) return;
    setError('');
    setEnviando(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email });
      setEnviado(res.data.mensaje);
    } catch (err) {
      setError(mensajeDeError(err, t('auth.forgot.errorFallback')));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      <LangToggle style={{ position: 'fixed', top: 12, right: 16, zIndex: 10 }} />
      {/* Teléfono: sin vídeo de fondo (pesa y gasta batería); queda el degradado. */}
      {!IS_PHONE && (
        <video className="login-video-bg" autoPlay muted playsInline loop>
          <source src="/videos/background.mp4" type="video/mp4" />
        </video>
      )}

      <div className="login-overlay" />

      <div className="login-container">
        <div className="login-card-glow">
          <div className="login-card">
            <div className="login-logo">
              <img src={logoSrc} alt="DragonAudio" className="logo-img" />
              <h1 className="login-title">DragonAudio</h1>
            </div>

            {enviado ? (
              // Ya se envió: se quita el formulario de en medio. Dejarlo puesto
              // invita a reenviar una y otra vez pensando que no funcionó, y solo
              // sirve para chocar contra el límite de envíos.
              <>
                <p className="login-aviso">{enviado}</p>
                <p className="login-pista">
                  {t('auth.forgot.linkHint')}
                </p>
                <p className="login-register">
                  <Link to="/">{t('auth.backToLogin')}</Link>
                </p>
              </>
            ) : (
              <>
                <h2 className="login-subtitulo">{t('auth.forgot.title')}</h2>
                <p className="login-pista login-pista--centrada">
                  {t('auth.forgot.intro')}
                </p>

                {error && <p className="login-error">{error}</p>}

                <form onSubmit={handleSubmit} className="login-form">
                  <input
                    type="email" placeholder={t('auth.field.email')} value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="login-input"
                    autoComplete="email" required autoFocus
                  />
                  <button type="submit" className="login-btn" disabled={enviando}>
                    {enviando ? t('auth.forgot.sending') : t('auth.forgot.submit')}
                  </button>
                </form>

                <p className="login-register">
                  <Link to="/">{t('auth.backToLogin')}</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
